/** @prettier */

/**
 * 実行確認ダイアログコンポーネント
 */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import {Navigate} from 'react-router-dom';
import {useState} from 'react';

//MTH component import
import APIErrorMessage from './APIErrorMessage';
import {PrimaryButton, SecondaryButton} from './BasicButton';

type Props = {
  open: boolean;
  setOpen: (arg0: boolean) => void;
  titleString: string;
  contentText: string;
  buttonNameLeft: string;
  buttonNameRight: string;
  execFunc: () => any;
  redirectPath: string;
  id?: string;
};

/**
 * 実行確認ダイアログ
 * @param {boolean} open useStateでbooleanを指定。Dialogを開くタイミングでTrueを入力 Dialogを閉じる入力は不要
 * @param {(arg0: boolean) => void} setOpen Openのset関数を指定
 * @param {string} titleString タイトルに表示する文字列を指定
 * @param {string} contentText 本文に表示する文字列を指定
 * @param {string} buttonNameLeft CANCELボタン名を指定
 * @param {string} buttonNameRight OKボタン名を指定
 * @param {() => any} execFunc OKボタン押下時に実行する関数を指定
 * @param {string} redirectPath 関数実行後、Redirectするパスを指定
 * @param {string} id ID
 */
const DialogPage = (props: Props) => {
  const [clickButton, setClickButton] = useState(false); //OK(右ボタン)がClickされたらTrue
  const [apiFin, setAPIFin] = useState(false); //APIの完了を待つフラグ
  const [errorOpen, setErrorOpen] = useState(false); //APIエラー時エラーメッセージ表示

  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setOpen(false);
  };

  /**
   * OKボタン押下時処理
   */
  const apiFunction = async () => {
    setClickButton(true);
    await props
      .execFunc()
      .then(() => {
        setAPIFin(true);
      })
      .catch(() => {
        setErrorOpen(true);
      })
      .finally(() => {
        setClickButton(false);
      });
  };

  return (
    <>
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id={props.id + 'Dialog'}>
        <DialogTitle id="alert-dialog-title">{props.titleString}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.contentText}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <SecondaryButton
            disabled={clickButton}
            onClick={handleClose}
            buttonText={props.buttonNameLeft}
            id={props.id + 'BtnCancel'}
          />
          <PrimaryButton
            onClick={apiFunction}
            buttonText={props.buttonNameRight}
            id={props.id + 'BtnOk'}
            apiWait={clickButton}
          />
          {/* API完了後、画面遷移 */}
          {apiFin && props.redirectPath !== '' ? (
            <Navigate to={props.redirectPath} />
          ) : (
            <></>
          )}
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={errorOpen}
        setOpen={setErrorOpen}
        id={'mv-btnErrDlg' + props.id}
      />
    </>
  );
};
export default DialogPage;
